/* RYZE bundle builder.
 *
 * Trust model, in one place so it cannot drift:
 *
 *  1. This script NEVER decides what anything costs. Shopify's "Any 2 x 50ml =
 *     1,290" automatic discount prices the cart. The figure rendered here is
 *     presentational only.
 *  2. It only ever handles NUMERIC variant ids, and every id is checked against
 *     the allow-list the server rendered into the picker before it is used.
 *     Nothing else can be added to the cart through this widget.
 *  3. No price is ever transmitted. /cart/add.js receives an id and a quantity.
 *  4. After adding, the real cart is read back. If Shopify charged something
 *     other than what was advertised, the REAL total replaces the advertised one
 *     and the customer is told. So even if the discount is edited or deleted in
 *     admin, this page cannot promise a price checkout will not honour.
 *  5. All text goes through textContent. No innerHTML anywhere.
 */

(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-ryze-bundle-builder]';
  var PAIR_SIZE = 2;

  /* ONE MONEY VOICE (dev2.15-fix-pdp, 30 Oct 2026): the cards' Liquid
     `money_without_trailing_zeros`, "LE 1,290" / "You save LE 410"; a real
     fraction keeps its two digits, exactly as the filter does. */
  function parseMoney(cents, format) {
    var whole = Math.round(cents) % 100 === 0;
    var value = (cents / 100).toLocaleString('en-EG', {
      minimumFractionDigits: whole ? 0 : 2,
      maximumFractionDigits: whole ? 0 : 2,
    });
    // Shopify money formats vary; "LE {{amount}}" covers this store, and the
    // fallback keeps the widget honest-looking on any other format.
    if (format && format.indexOf('{{') !== -1) {
      return format.replace(/\{\{\s*amount[^}]*\}\}/, value).replace(/<[^>]*>/g, '');
    }
    return 'LE ' + value;
  }


  /* Writes a chosen fragrance's display name: the Arabic wordmark image when
     the catalogue carries one (Leen), plain text otherwise. createElement
     only - the file's no-innerHTML contract holds - and the image's alt
     keeps the spoken name, so screen readers hear the same word everywhere. */
  function setDisplayName(el, entry) {
    if (!el) return;
    el.textContent = '';
    if (entry.arMark) {
      var mark = document.createElement('img');
      mark.className = 'ryze-bb__name-ar';
      mark.src = entry.arMark;
      mark.alt = entry.title;
      mark.width = 68;
      mark.height = 72;
      mark.decoding = 'async';
      el.appendChild(mark);
    } else {
      el.textContent = entry.title;
    }
  }

  function BundleBuilder(root) {
    this.root = root;
    this.discount = Number(root.dataset.discount) || 0;
    this.threshold = Number(root.dataset.threshold) || 0;
    this.moneyFormat = root.dataset.moneyFormat || '';

    this.sheet = root.querySelector('.ryze-bb__sheet');
    this.slots = Array.prototype.slice.call(root.querySelectorAll('.ryze-bb__slot'));
    this.summary = root.querySelector('.ryze-bb__summary');
    this.thirdWrap = root.querySelector('.ryze-bb__third');
    this.thirdBtn = root.querySelector('.ryze-bb__third-btn');
    this.thirdFilled = root.querySelector('.ryze-bb__third-filled');
    this.msg = root.querySelector('.ryze-bb__msg');
    this.addBtn = root.querySelector('.ryze-bb__cta--add');
    this.buyBtn = root.querySelector('.ryze-bb__cta--buy');
    this.film = root.querySelector('.ryze-bb__film');

    // Server-rendered allow-list. Nothing outside this can reach the cart.
    this.catalogue = {};
    var self = this;
    Array.prototype.forEach.call(root.querySelectorAll('.ryze-bb__option'), function (opt) {
      var id = Number(opt.dataset.variantId);
      if (!Number.isInteger(id) || id <= 0) return;
      self.catalogue[id] = {
        id: id,
        price: Number(opt.dataset.price) || 0,
        title: opt.dataset.title || '',
        image: opt.dataset.image || '',
        /* Leen's display name is the Arabic wordmark image (owner 2026-08-04);
           the URL rides on the server-rendered option, so the script never
           invents a path. Text names stay for every aria string. */
        arMark: opt.dataset.arMark || '',
        available: !opt.disabled,
      };
    });

    // selection[0] and [1] are the pair; [2] is the optional third bottle.
    this.selection = [null, null, null];
    this.activeSlot = 0;
    this.busy = false;

    /* THE PRICE CARD AT REST (dev2.15-yes3, 30 Oct 2026): from 990 the price panel is the
       third card beside the cells and stands before any pick; the desk query decides, and a
       window crossing 990 re-renders. */
    this.deskMq = typeof window.matchMedia === 'function' ? window.matchMedia('(min-width: 990px)') : null;
    if (this.deskMq) {
      var onDesk = function () { self.render(); };
      if (typeof this.deskMq.addEventListener === 'function') this.deskMq.addEventListener('change', onDesk);
      else if (typeof this.deskMq.addListener === 'function') this.deskMq.addListener(onDesk);
    }

    /* the backdrop is set up FIRST, before bind(): an error while binding the
       controls can no longer leave the section on an empty box (the perf
       refuter, 30 Oct 2026) */
    this.setupBackdrop();
    this.bind();
    this.setupFilm();
    this.restoreSelection();
    /* THE PRICE CARD AT REST: a fresh page renders once too (restoreSelection renders only
       what it restored), so the panel stands from the first paint on a desk. */
    this.render();
  }

  /* dev2.14-perf (2026-10-30, W3): THE BACKDROP WAITS. The artwork (the
     poster and the identical background under it, see the section) is set
     when the section comes within 1500 px of the screen, not at parse time:
     it rode the homepage's first paint four sections below the fold. Runs
     first in the constructor (before bind and setupFilm) and outside
     setupFilm's reduced-motion and no-observer exits, so the still always
     arrives; without an observer it is set at once. 1500 px, not 600 (the
     perf refuter, 30 Oct 2026): at 600 px a slow link (1.6 Mbps / 150 ms)
     could show the builder's empty box to a reader scrolling in; 1500 px
     still keeps the 78 KB still out of the homepage's first paint. */
  BundleBuilder.prototype.setupBackdrop = function () {
    var film = this.film;
    if (!film) return;
    var put = function () {
      var poster = film.getAttribute('data-poster');
      var bg = film.getAttribute('data-backdrop');
      if (poster && !film.getAttribute('poster')) film.setAttribute('poster', poster);
      /* the inline `background` shorthand already reports background-image "initial", so a flag, not the style, says it is set */
      if (bg && film.dataset.bgSet !== '1') { film.style.backgroundImage = 'url("' + bg + '")'; film.dataset.bgSet = '1'; }
    };
    if (!('IntersectionObserver' in window)) { put(); return; }
    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i += 1) {
        if (entries[i].isIntersecting) { put(); io.disconnect(); return; }
      }
    }, { rootMargin: '1500px 0px' });
    io.observe(film);
  };

  /* ---------- the artwork film ---------- */

  /* The Summer Bundle artwork behind this section is a film: the same frame the
     still showed, with the leaf shadows moving across it. Four things are true of
     it, and they are the whole design.

       1. It costs NOTHING until it is near the viewport. The section is below the
          fold, so the element ships with no `src` at all and this promotes
          `data-src` only when the observer says it is close. Since dev2.14-perf
          the 78 KB still (poster + background) waits too: setupBackdrop sets it
          when the section is 1500 px away, so a visitor who never scrolls near
          pays for nothing (the film itself is retired, see the section). Same
          pattern as the hero film in ryze-hero.js, for the same reason.
       2. It never runs off screen. Leaving the viewport pauses it, hiding the tab
          pauses it, and coming back to either resumes it.
       3. It never runs at all under `prefers-reduced-motion: reduce`. Looping
          background motion is precisely what that setting asks not to see, and
          because the poster IS the film's first frame the section still looks
          exactly as designed, simply still.
       4. No film failure leaves an empty box. No observer, no autoplay
          permission, a file that will not decode: each ends with the still
          showing, because setupBackdrop sets it on its own, first in the
          constructor, whatever this function does. What it cannot cover is a
          page whose scripts never run: JavaScript off is answered by the
          section's <noscript> rule, which paints the same still as the
          background (the perf refuter, 30 Oct 2026).

     The loop seam needs nothing from here. It is solved in the ENCODE: the file is
     a PALINDROME (forward then reverse, every joint an ordinary frame step); a
     crossfade was built once and REJECTED because it visibly resizes the drifting
     bottles. The `loop` attribute is correct and sufficient. A scripted crossfade,
     a second stacked element or a fade overlay would each be more code AND a
     visibly worse result. */
  BundleBuilder.prototype.setupFilm = function () {
    var film = this.film;
    if (!film) return;

    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    /* Without IntersectionObserver there is no way to know when the film is close,
       and fetching it on load for a section below the fold is exactly what this
       whole arrangement exists to avoid. So it is never fetched, and the poster
       stays. Cheaper than the alternative, and the section still reads as intended. */
    if (!('IntersectionObserver' in window)) return;

    var self = this;
    var fetched = false;
    this.filmOnScreen = false;

    var start = function () {
      if (!fetched) {
        fetched = true;
        var src = film.dataset.src;
        if (!src) return;
        film.setAttribute('src', src);
        film.load();
      }
      var p = film.play();
      // Autoplay can still be refused, and that is not an error worth surfacing:
      // the poster is already painted, so a refusal simply leaves the still.
      if (p && typeof p.catch === 'function') p.catch(function () {});
    };

    var stop = function () {
      if (!film.paused) film.pause();
    };

    /* If the file cannot be decoded, put the element back in the state it was in
       before it was asked to play: no source, poster showing. Without this the panel
       would render as an empty box, which is the one outcome worth real code to
       prevent. It cannot re-enter, because `fetched` stays true and an element with
       no source raises no further error. */
    film.addEventListener('error', function () {
      film.removeAttribute('src');
      film.load();
    });

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          self.filmOnScreen = e.isIntersecting;
          if (e.isIntersecting) {
            start();
          } else {
            stop();
          }
        });
      },
      // Enough margin to have the file in hand by the time the section arrives,
      // not so much that scrolling past the hero already pays for it.
      { rootMargin: '200px 0px' }
    );
    io.observe(film);

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stop();
      } else if (self.filmOnScreen) {
        start();
      }
    });
  };

  BundleBuilder.prototype.bind = function () {
    var self = this;

    this.slots.forEach(function (slot) {
      slot.addEventListener('click', function () {
        self.openSheet(Number(slot.dataset.slot));
      });
    });

    if (this.thirdBtn) {
      this.thirdBtn.addEventListener('click', function () {
        self.openSheet(2);
      });
    }

    Array.prototype.forEach.call(this.root.querySelectorAll('[data-clear]'), function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var index = Number(btn.dataset.clear);
        /* THE FOCUS STAYS (the duo refuter, 30 Oct 2026): the x hides itself, so a
           keyboard user who pressed it fell to <body>. When the x held focus, focus
           moves to what now stands in its place: the emptied cell, or the third
           row's invitation. A mouse click on Safari never focuses the x, so nothing
           moves for a pointer there; Chrome's programmatic focus after a click
           paints no ring. preventScroll: the page stays where the reader is. */
        var hadFocus = document.activeElement === btn;
        self.clearSlot(index);
        if (hadFocus) self.focusAfterClear(index);
      });
    });

    Array.prototype.forEach.call(this.root.querySelectorAll('.ryze-bb__option'), function (opt) {
      if (opt.disabled) return;
      opt.addEventListener('click', function () {
        self.choose(Number(opt.dataset.variantId));
      });
    });

    var close = this.root.querySelector('.ryze-bb__sheet-close');
    if (close) {
      close.addEventListener('click', function () {
        self.closeSheet();
      });
    }

    if (this.sheet) {
      // Clicking the backdrop closes. The dialog element itself fills the
      // viewport, so a click landing on it rather than its inner panel is a
      // backdrop click.
      this.sheet.addEventListener('click', function (e) {
        if (e.target === self.sheet) self.closeSheet();
      });

      // Every dismissal path ends in a close event, including the Escape key,
      // so releasing the scroll lock here means it can never be left stuck.
      this.sheet.addEventListener('close', function () {
        self.unlockScroll();
      });
    }

    if (this.addBtn) {
      this.addBtn.addEventListener('click', function () {
        self.submit(false);
      });
    }
    if (this.buyBtn) {
      this.buyBtn.addEventListener('click', function () {
        self.submit(true);
      });
    }
  };

  /* ---------- picker ---------- */

  /* iOS Safari lets a touch drag scroll the page behind an open <dialog>:
     showModal() blocks the document scroller on desktop but not touch
     scrolling underneath. Pinning the body is the only reliable fix, so the
     scroll position is stashed, the body is frozen in place, and the position
     is restored on close. Only the properties set here are cleared again, so
     the padding-top the announcement bar maintains is left alone. */
  BundleBuilder.prototype.lockScroll = function () {
    if (this.scrollLocked) return;
    this.scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    var b = document.body;
    b.style.position = 'fixed';
    b.style.top = -this.scrollY + 'px';
    b.style.left = '0';
    b.style.right = '0';
    b.style.width = '100%';
    this.scrollLocked = true;
  };

  BundleBuilder.prototype.unlockScroll = function () {
    if (!this.scrollLocked) return;
    var b = document.body;
    b.style.position = '';
    b.style.top = '';
    b.style.left = '';
    b.style.right = '';
    b.style.width = '';
    this.scrollLocked = false;

    /* Instant, and it has to be FORCED. `window.scrollTo(x, y)` obeys the CSS
       `scroll-behavior` of the scrolling element, and this theme carries
       `html:has(:target) { scroll-behavior: smooth }`. The hero's "Build Your Pair"
       button puts #ryze-bundle in the URL, so :target matches on exactly the page
       this sheet opens from: the restore then ANIMATED, and because unpinning the
       body also jumps the page, closing the picker visibly raced up and down before
       settling. Overriding the property for the duration is the one approach that
       works on every engine, including those that ignore behavior: 'instant'. */
    var root = document.documentElement;
    var prev = root.style.scrollBehavior;
    root.style.scrollBehavior = 'auto';
    window.scrollTo(0, this.scrollY || 0);
    root.style.scrollBehavior = prev;
  };

  BundleBuilder.prototype.openSheet = function (slotIndex) {
    this.activeSlot = slotIndex;
    this.lastFocus = document.activeElement;
    if (!this.sheet) return;
    this.lockScroll();
    if (typeof this.sheet.showModal === 'function') {
      this.sheet.showModal();
    } else {
      this.sheet.setAttribute('open', '');
    }
    var first = this.sheet.querySelector('.ryze-bb__option:not([disabled])');
    if (first) first.focus();
  };

  BundleBuilder.prototype.closeSheet = function () {
    if (!this.sheet) return;
    if (typeof this.sheet.close === 'function' && this.sheet.open) {
      this.sheet.close();
    } else {
      this.sheet.removeAttribute('open');
    }
    this.unlockScroll();
    if (this.lastFocus && typeof this.lastFocus.focus === 'function') {
      // preventScroll, or the browser scrolls the slot back into view and undoes
      // the position we just restored.
      try {
        this.lastFocus.focus({ preventScroll: true });
      } catch (e) {
        this.lastFocus.focus();
      }
    }
  };

  BundleBuilder.prototype.choose = function (variantId) {
    var item = this.catalogue[variantId];
    if (!item || !item.available) return;
    this.selection[this.activeSlot] = item;
    this.closeSheet();
    this.render();
    this.saveSelection();
  };

  BundleBuilder.prototype.focusAfterClear = function (slotIndex) {
    var target = slotIndex < 2 ? this.slots[slotIndex] : this.thirdBtn;
    if (!target || typeof target.focus !== 'function') return;
    try {
      target.focus({ preventScroll: true });
    } catch (e) {
      target.focus();
    }
  };

  BundleBuilder.prototype.clearSlot = function (slotIndex) {
    this.selection[slotIndex] = null;
    this.setMessage('', null);
    this.render();
    this.saveSelection();
  };

  /* ---------- persistence ----------

     A refresh used to wipe a half-built pair, because the selection lived only
     in this object. It now survives in sessionStorage: the same tab keeps the
     pair through refreshes and navigation, and a closed tab forgets it, which
     is the right lifetime for a purchase in progress. Only VARIANT IDS are
     stored, never prices or titles: on restore each id is re-resolved against
     the freshly server-rendered catalogue, so a price change, a delisting or a
     sell-out between sessions is picked up rather than replayed. An id that no
     longer resolves, or resolves unavailable, is dropped silently.

     Every read and write is wrapped, because Safari private mode throws on the
     storage object itself. Same convention as ryze-wishlist.js. */

  var STORE_KEY = 'ryze_bb_selection';

  BundleBuilder.prototype.saveSelection = function () {
    try {
      var ids = this.selection.map(function (item) { return item ? item.id : null; });
      if (ids[0] === null && ids[1] === null && ids[2] === null) {
        sessionStorage.removeItem(STORE_KEY);
      } else {
        sessionStorage.setItem(STORE_KEY, JSON.stringify(ids));
      }
    } catch (e) {
      /* storage unavailable: the builder still works, it just forgets on refresh */
    }
  };

  BundleBuilder.prototype.restoreSelection = function () {
    var ids;
    try {
      ids = JSON.parse(sessionStorage.getItem(STORE_KEY) || 'null');
    } catch (e) {
      ids = null;
    }
    if (!Array.isArray(ids)) return;

    var restored = false;
    for (var i = 0; i < 3; i++) {
      var item = this.catalogue[Number(ids[i])];
      if (item && item.available) {
        this.selection[i] = item;
        restored = true;
      }
    }

    /* A third bottle with an incomplete pair cannot exist through the UI, so
       do not resurrect one: it would reveal a row the render path expects to
       be gated behind pairComplete. */
    if (!(this.selection[0] && this.selection[1])) this.selection[2] = null;

    if (restored) {
      this.render();
      /* What was dropped (sold out since, delisted) should also stop being
         remembered, so the stored state always mirrors the rendered state. */
      this.saveSelection();
    }
  };

  /* ---------- render ---------- */

  BundleBuilder.prototype.render = function () {
    var self = this;

    this.slots.forEach(function (slot, i) {
      var picked = self.selection[i];
      var empty = slot.querySelector('.ryze-bb__slot-empty');
      var filled = slot.querySelector('.ryze-bb__slot-filled');
      var clear = self.root.querySelector('[data-clear="' + i + '"]');

      /* The base label ("<slot label> N") is remembered once, then the
         accessible name FOLLOWS the visible content: a filled slot shows
         the fragrance name, and a name that does not contain the visible
         text fails WCAG 2.5.3 (Part8 a11y audit). */
      if (!slot.dataset.baseLabel) slot.dataset.baseLabel = slot.getAttribute('aria-label') || '';

      if (picked) {
        slot.classList.add('is-filled');
        empty.hidden = true;
        filled.hidden = false;
        var img = filled.querySelector('.ryze-bb__slot-img');
        if (img) {
          img.src = picked.image;
          img.alt = picked.title;
        }
        setDisplayName(filled.querySelector('.ryze-bb__slot-name'), picked);
        if (slot.dataset.baseLabel) slot.setAttribute('aria-label', picked.title + '. ' + slot.dataset.baseLabel);
        if (clear) {
          /* The x names what it removes (the refuter: "Remove fragrance 1" named a position). */
          clear.setAttribute('aria-label', 'Remove ' + picked.title);
          clear.hidden = false;
        }
      } else {
        slot.classList.remove('is-filled');
        empty.hidden = false;
        filled.hidden = true;
        if (slot.dataset.baseLabel) slot.setAttribute('aria-label', slot.dataset.baseLabel);
        if (clear) clear.hidden = true;
      }
    });

    var pairComplete = !!(this.selection[0] && this.selection[1]);

    if (this.thirdWrap) this.thirdWrap.hidden = !pairComplete;
    this.renderThird();

    /* THE PRICE CARD AT REST (dev2.15-yes3): on a desk the panel stands before the pair is
       complete, with the pair's own price and the rest line; phones and tablets keep it for
       the complete pair. A pick changes the card's words, never the row (THE STILL CARD). */
    var desk = !!(this.deskMq && this.deskMq.matches);
    if (this.summary) {
      this.summary.hidden = !pairComplete && !desk;
      this.summary.classList.toggle('is-rest', !pairComplete);
    }
    if (pairComplete) this.renderTotals();
    else if (desk) this.renderRestTotals();

    /* Dynamic CTA copy: two bottles read the pair labels, a third flips both
       buttons to the "all" labels. Both strings are owner-editable and ride on
       the buttons as data attributes; the script only chooses, never writes
       copy of its own. */
    var three = !!this.selection[2];
    [this.addBtn, this.buyBtn].forEach(function (btn) {
      if (!btn) return;
      var textEl = btn.querySelector('.ryze-bb__cta-text');
      var label = three ? btn.dataset.labelAll : btn.dataset.labelPair;
      if (textEl && label) textEl.textContent = label;
    });
  };

  BundleBuilder.prototype.renderThird = function () {
    var third = this.selection[2];
    if (!this.thirdBtn || !this.thirdFilled) return;

    if (third) {
      this.thirdBtn.hidden = true;
      this.thirdFilled.hidden = false;
      var img = this.thirdFilled.querySelector('.ryze-bb__third-img');
      if (img) {
        img.src = third.image;
        img.alt = third.title;
      }
      setDisplayName(this.thirdFilled.querySelector('.ryze-bb__third-name'), third);
      var clear3 = this.thirdFilled.querySelector('[data-clear]');
      if (clear3) clear3.setAttribute('aria-label', 'Remove ' + third.title);
    } else {
      this.thirdBtn.hidden = false;
      this.thirdFilled.hidden = true;
      var gap = this.threshold - this.expectedTotal();
      var label = this.thirdBtn.querySelector('.ryze-bb__third-text');
      if (label) {
        label.textContent =
          gap > 0
            ? 'Add a third for free delivery'
            : 'Add a third fragrance';
      }
    }
  };

  BundleBuilder.prototype.chosenItems = function () {
    return this.selection.filter(Boolean);
  };

  /* Advertised total: real variant prices, minus one pair saving for every
     complete pair. Presentational only; the cart decides. */
  BundleBuilder.prototype.expectedTotal = function () {
    var items = this.chosenItems();
    var gross = items.reduce(function (sum, it) {
      return sum + it.price;
    }, 0);
    var pairs = Math.floor(items.length / PAIR_SIZE);
    return gross - pairs * this.discount;
  };

  BundleBuilder.prototype.expectedGross = function () {
    return this.chosenItems().reduce(function (sum, it) {
      return sum + it.price;
    }, 0);
  };

  BundleBuilder.prototype.paintTotals = function (gross, net) {
    var saved = gross - net;

    var wasEl = this.root.querySelector('.ryze-bb__was');
    var nowEl = this.root.querySelector('.ryze-bb__now');
    var saveEl = this.root.querySelector('.ryze-bb__save');

    if (wasEl) wasEl.textContent = saved > 0 ? parseMoney(gross, this.moneyFormat) : '';
    if (nowEl) nowEl.textContent = parseMoney(net, this.moneyFormat);
    if (saveEl) {
      saveEl.textContent = saved > 0 ? 'You save ' + parseMoney(saved, this.moneyFormat) : '';
      saveEl.hidden = saved <= 0;
    }
  };

  BundleBuilder.prototype.renderTotals = function (actualCents) {
    var gross = this.expectedGross();
    var net = typeof actualCents === 'number' ? actualCents : this.expectedTotal();
    this.paintTotals(gross, net);
    this.renderShipping(net);
  };

  /* THE PRICE CARD AT REST (dev2.15-yes3): before a pick the panel speaks the pair's own
     price, the two lowest-priced bottles on offer minus the pair saving (every 50 ml is one
     price today, so this IS the pair price; a cheaper scent one day would read as a "from").
     Presentational only, as the totals are; the meter waits for a real pair. */
  BundleBuilder.prototype.renderRestTotals = function () {
    var prices = [];
    for (var id in this.catalogue) {
      if (Object.prototype.hasOwnProperty.call(this.catalogue, id) && this.catalogue[id].available) {
        prices.push(this.catalogue[id].price);
      }
    }
    if (prices.length < PAIR_SIZE) return;
    prices.sort(function (a, b) { return a - b; });
    var gross = prices[0] + prices[1];
    this.paintTotals(gross, gross - this.discount);
    var ship = this.root.querySelector('.ryze-bb__ship');
    if (ship) ship.hidden = true;
  };

  BundleBuilder.prototype.renderShipping = function (net) {
    var wrap = this.root.querySelector('.ryze-bb__ship');
    if (!wrap || !this.threshold) return;

    var fill = wrap.querySelector('.ryze-bb__ship-fill');
    var text = wrap.querySelector('.ryze-bb__ship-text');
    var pct = Math.min((net / this.threshold) * 100, 100);
    var gap = this.threshold - net;

    wrap.hidden = false;
    if (fill) fill.style.width = pct + '%';

    /* The bar is the cart page's free-shipping bar verbatim (owner 2026-08-04),
       so both states speak that bar's exact words and flip its exact
       --complete class; ryze-bb__ship--done stays for the script's own state. */
    if (gap > 0) {
      wrap.classList.remove('ryze-bb__ship--done', 'ryze-free-ship--complete');
      if (text) {
        text.textContent = '';
        text.appendChild(document.createTextNode('You’re '));
        var strong = document.createElement('strong');
        strong.textContent = parseMoney(gap, this.moneyFormat);
        text.appendChild(strong);
        text.appendChild(document.createTextNode(' away from '));
        var strongFree = document.createElement('strong');
        strongFree.textContent = 'free delivery';
        text.appendChild(strongFree);
      }
    } else {
      wrap.classList.add('ryze-bb__ship--done', 'ryze-free-ship--complete');
      if (text) {
        text.textContent = '';
        var strongDone = document.createElement('strong');
        strongDone.textContent = 'Free delivery unlocked';
        text.appendChild(strongDone);
      }
    }
  };

  BundleBuilder.prototype.setMessage = function (msg, kind) {
    if (!this.msg) return;
    this.msg.textContent = msg;
    this.msg.className = 'ryze-bb__msg' + (kind ? ' ryze-bb__msg--' + kind : '');
  };

  /* ---------- cart ---------- */

  /* Hardened 2026-07-31 (Part8), to the 100 ml / promo standard:
     1. The STATUS decides the outcome, never the parse: a 429 answers
        text/plain, and the old chain's bare res.json() rejected with the
        browser's own wording, which was then shown to the customer.
     2. The add and everything after it are SEPARATE outcomes. The old
        chain read /cart.js inside the same .then() ladder, so a
        throttled read painted a completed add as a failure — which is
        how a customer presses again and buys the same pair twice.
     3. Busy is aria-disabled + the busy guard, never the disabled
        property: these are the buttons holding focus when pressed.
     4. ONE payload entry per variant with the summed quantity (two of
        the same fragrance is one line, not two).
     5. routeRoot() everywhere; only a ryzeSafe error or Shopify's own
        description is ever quoted.
     6. Feedback: the old success message was written into the summary
        and reset() collapsed the summary in the same tick, so a
        successful add showed NOTHING. The cart toast now carries it
        (it lives outside this section), and the real /cart.js response
        is published as cartUpdate so the guarded badge subscribers and
        the promo engine hear the add. */

  function routeRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    return '/';
  }

  BundleBuilder.prototype.submit = function (goToCheckout) {
    if (this.busy) return;
    var items = this.chosenItems();
    if (items.length < PAIR_SIZE) return;

    // Re-validate every id against the server-rendered allow-list immediately
    // before the request, not just at selection time.
    var byId = {};
    var order = [];
    var names = [];
    for (var i = 0; i < items.length; i++) {
      var entry = this.catalogue[items[i].id];
      if (!entry || !entry.available) {
        this.setMessage('That fragrance just became unavailable. Please choose another.', 'error');
        return;
      }
      if (byId[entry.id]) {
        byId[entry.id].quantity += 1;
      } else {
        byId[entry.id] = { id: entry.id, quantity: 1 };
        order.push(entry.id);
        if (entry.title) names.push(entry.title);
      }
    }
    var payload = [];
    for (var k = 0; k < order.length; k++) payload.push(byId[order[k]]);

    this.busy = true;
    var pressed = goToCheckout ? this.buyBtn : this.addBtn;
    if (pressed) pressed.classList.add('is-busy');
    if (this.addBtn) this.addBtn.setAttribute('aria-disabled', 'true');
    if (this.buyBtn) this.buyBtn.setAttribute('aria-disabled', 'true');
    this.setMessage('', null);

    var self = this;
    var release = function () {
      self.busy = false;
      if (self.addBtn) {
        self.addBtn.removeAttribute('aria-disabled');
        self.addBtn.classList.remove('is-busy');
      }
      if (self.buyBtn) {
        self.buyBtn.removeAttribute('aria-disabled');
        self.buyBtn.classList.remove('is-busy');
      }
    };

    fetch(routeRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: payload }),
    })
      .then(function (res) {
        return res
          .json()
          ['catch'](function () {
            return null;
          })
          .then(function (body) {
            if (!res.ok) {
              var err = new Error(body && body.description ? body.description : 'Could not add to cart.');
              err.ryzeSafe = true;
              throw err;
            }
            return body;
          });
      })
      .then(function () {
        /* Past this line the bundle IS in the cart. Nothing below may be
           reported as a failed add. */
        if (goToCheckout) {
          /* Stay busy through the navigation, and navigate only on a
             CONFIRMED add — the old code could reach /checkout while
             showing an error, or error while the pair was already in.
             CODE-05 (2026-10-18): a back from checkout that restores this
             page from the bfcache releases the buttons. MSR-01: the pixels'
             AddToCart leaves before the page does (1.5 s, bounded). */
          window.addEventListener('pageshow', function (e) {
            if (e.persisted) release();
          }, { once: true });
          setTimeout(function () {
            window.location.href = routeRoot() + 'checkout';
          }, 0); // MSR-01 hold parked at 0 for the owner's call (1500 = the measured pixel wait)
          return null;
        }

        release();
        if (window.RyzeToast && typeof window.RyzeToast.show === 'function') {
          window.RyzeToast.show(names.length ? names.join(' + ') : 'Your bundle', 'added');
        }
        /* The promo engine listens and re-reads the cart itself. */
        try {
          document.dispatchEvent(new CustomEvent('ryze:cart:updated', { detail: {} }));
        } catch (e) {
          /* an un-notified promo engine still hears the badge observer */
        }
        self.reset();

        /* Best effort from here down: a failed read costs the badge and
           the publish, never the truth. */
        return fetch(routeRoot() + 'cart.js', {
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
        })
          .then(function (r) {
            return r.ok ? r.json() : null;
          })
          ['catch'](function () {
            return null;
          });
      })
      .then(function (cart) {
        if (!cart) return;
        /* The real /cart.js response, never the add response. The guarded
           subscribers (ryze-custom.js) write the header + hamburger badges
           with the marker + boot-anchor discipline. */
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ryze-bundle-builder', cartData: cart });
        }
      })
      ['catch'](function (err) {
        release();
        self.setMessage(err && err.ryzeSafe && err.message ? err.message : 'Something went wrong. Please try again.', 'error');
      });
  };

  BundleBuilder.prototype.reset = function () {
    this.selection = [null, null, null];
    this.render();
    /* The pair is in the cart now; a refresh must not offer to build it again. */
    this.saveSelection();
  };

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll(ROOT_SELECTOR), function (root) {
      if (root.dataset.bbReady) return;
      root.dataset.bbReady = '1';
      new BundleBuilder(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
